import { NavLink } from 'react-router-dom'

import logo from '../logo.png'
import SidebarTitlesMenu from './SidebarTitlesMenu'

import { FiHome } from 'react-icons/fi'
import { TbShoppingCartSearch } from 'react-icons/tb'
import { BiUser } from 'react-icons/bi'
import { AiOutlineShopping } from 'react-icons/ai'
import { FaRegChartBar } from 'react-icons/fa'

export default function Sidebar({ buyer, publisher, producer }) {
  return (
    <>
      <nav className='navbarSide'>
        <div className='logo'>
          <img src={logo} alt='' />
        </div>

        <menu>
          <NavLink to={''} end>
            <FiHome />
            <span>داشبورد</span>
          </NavLink>

          {buyer && <NavLink to={'/purchased'}>
            <AiOutlineShopping />
            <span>خرید های من</span>
          </NavLink>}


          {publisher || producer ? <>
            <hr style={{ opacity: .1 }} />
            <NavLink to={'/orders'}>
              <TbShoppingCartSearch />
              <span>سفارشات</span>
            </NavLink>

            <NavLink to={'/reports'}>
              <FaRegChartBar />
              <span>گزارشات</span>
            </NavLink>
            <hr style={{ opacity: .1 }} />
          </> : ''}


          <SidebarTitlesMenu />

          <NavLink to={'/profile'}>
            <BiUser />
            <span>پروفایل</span>
          </NavLink>

        </menu>

        <div className='versionApp'>نسخه: 2.5.0</div>
      </nav>
    </>
  )
}
